var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBucket = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "18px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "black",
    d: "M63.95,15.786c0,4.006-12.963,7.238-28.949,7.238 c-15.988,0-28.951-3.232-28.951-7.238l9.65,43.839c0,2.672,8.637,4.826,19.301,4.826c10.662,0,19.299-2.154,19.299-4.826l0,0 L63.95,15.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "black",
    d: "M63.95,12.786c0-4.004-12.963-7.237-28.949-7.237 c-15.988,0-28.951,3.233-28.951,7.237c0,4.006,12.963,7.238,28.951,7.238C50.987,20.024,63.95,16.792,63.95,12.786L63.95,12.786 z"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBucket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bucket.0efb2562.svg";
export { ForwardRef as ReactComponent };